import React from 'react';
import { environments } from 'environments/environments';
import { byOrder } from 'libs/functions/order';
import { GalleryImage, Gallery } from '../Gallery.interface';
import GalleryInfo from './GalleryInfo/GalleryInfo';
import { Link } from 'react-router-dom';
import './SingleGalleryFull.css';
import { linkize, removeDiacritics } from 'libs/functions/string-operations';
import PhotoDisplay from 'libs/components/PhotoDisplay/PhotoDisplay';

export default class SingleGalleryFull extends React.Component {
  galleryId = 0;

  state = {
    info: undefined as Gallery | undefined,
    images: [] as GalleryImage[],
    displayedImage: 0,
    loadingInfo: false,
    loadingImages: false
  }

  componentDidMount() {
    this.getGalleryId()
    this.getGalleryInfo();
    this.getImageList();
    this.openImage(this.getImageId((this.props as any).match.params.fid));
  }

  componentDidUpdate() {
    this.checkDisplayedImage();
  }

  getGalleryId() {
    const wholeGalleryId = `${(this.props as any).match.params.gid}`;
    this.galleryId = +wholeGalleryId.split('-')[0];
  }

  getGalleryInfo() {
    this.setState({ loadingInfo: true });
    const params = `?t=galleries&count=1&c=id=${this.galleryId}`;
    const anticache = '&anticache=' + Date.now();
    fetch(environments.server + environments.backend + params + anticache)
      .then(res => res.json())
      .then((res: any) => {
        if (res && res.length && res[0].id) {
          this.setState({ info: res[0], loadingInfo: false });
        } else {
          this.setState({ info: undefined, loadingInfo: false });
        }
      });
  }

  getImageList() {
    this.setState({ loadingImages: true });
    const params = `?t=images&count=0&c=gallery=${this.galleryId}`;
    const anticache = '&anticache=' + Date.now();
    fetch(environments.server + environments.backend + params + anticache)
      .then(res => res.json())
      .then((res: any) => {
        if (res && res.length) {
          const imageList = res.sort(byOrder);
          this.setState({ images: imageList, loadingImages: false });
        } else {
          this.setState({ images: [], loadingImages: false });
        }
      });
  }

  getImageId(image: string) {
    return image
      ? +image.split('-')[0]
      : 0;
  }

  openImage(imageId: number) {
    this.setState({ displayedImage: imageId });
  }

  checkDisplayedImage() {
    const newImageId = this.getImageId((this.props as any).match.params.fid);
    if (+this.state.displayedImage !== newImageId) {
      this.openImage(newImageId);
    }
  }

  render() {
    const linkName = this.state.info ? linkize(removeDiacritics(this.state.info.name), '-') : '';
    const renderPhotos = this.state.images.map(image => {
      const imageSrc =  `${environments.server}/img/${image.thumbnail || image.filename}`;
      const wideClass = image.width > image.height ? '' : 'single-photo-wide';
      return (
        <div className={"single-photo " + wideClass} key={image.id}>
          <Link
            to={`/fotky/${this.galleryId}-${linkName}/${image.id}-${image.filename.replace(/\//g, '')}`}
            className="single-photo-box"
            onClick={() => this.openImage(+image.id)}
          >
            <img src={imageSrc} alt="" />
          </Link>
        </div>
      );
    });

    return (
      <div className="section gallery">
        <Link to="/fotky" className="event-link-back">&larr; Zpět na seznam galerií</Link>
        {this.state.loadingInfo
          ? <p className='loading-info'><span className="loading loading-spinner"></span> Načítají se informace o galerii...</p>
          : this.state.info
            ? <GalleryInfo gallery={this.state.info} />
            : <p className='loading-info'>Při načítání fotogalerie došlo k chybě, zkusit <span onClick={() => this.getGalleryInfo()}>ZNOVU</span>?</p>
        }
        <div className="photo-box">
          {this.state.loadingImages
            ? <p className='loading-info'><span className="loading loading-spinner"></span> Načítají se fotky...</p>
            : this.state.images
              ? renderPhotos
              : <p className='loading-info'>Při načítání obsahu fotogalerie došlo k chybě, zkusit <span onClick={() => this.getImageList()}>ZNOVU</span>?</p>
          }
        </div>
        {this.state.displayedImage
          ? <PhotoDisplay
            activePhoto={this.state.displayedImage}
            photoList={this.state.images}
            galleryName={this.state.info ? this.state.info.name : ''}
          />
          : null
        }
      </div>
    )
  }
}
